var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoundOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 40.5,
    height: 40.5,
    rx: 20.25,
    stroke: "#00C8D5",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9038 16.47H11.3338C10.4038 16.47 9.6438 17.23 9.6438 18.16V23.84C9.6438 24.77 10.4038 25.53 11.3338 25.53H15.9038L16.7738 26.18L23.6838 31.36V10.64L16.7738 15.82L15.9038 16.47ZM28.9638 22.1L26.9038 24.16C26.7538 24.31 26.5538 24.39 26.3438 24.39C26.1338 24.39 25.9438 24.31 25.7838 24.16C25.4738 23.85 25.4738 23.36 25.7838 23.05L27.8438 20.99L25.7838 18.93C25.4738 18.62 25.4738 18.13 25.7838 17.82C26.0938 17.51 26.5838 17.51 26.8938 17.82L28.9538 19.88L31.0138 17.82C31.3238 17.51 31.8138 17.51 32.1238 17.82C32.4338 18.13 32.4338 18.62 32.1238 18.93L30.0638 20.99L32.1238 23.05C32.4338 23.36 32.4338 23.85 32.1238 24.16C31.9738 24.31 31.7738 24.39 31.5638 24.39C31.3538 24.39 31.1638 24.31 31.0038 24.16L28.9438 22.1H28.9638Z",
    fill: "#00C8D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/SoundOff.3f20a906240d638720b9a4624fc6563c.svg";
export { ForwardRef as ReactComponent };